import { ProfileCore, type ProfileCoreProps } from './ProfileCore';

export type CompactLongitudinalProfileProps = Omit<ProfileCoreProps, 'layout' | 'dynamic' | 'headerExtra' | 'renderExpandedBefore' | 'renderProfileExtra'>;

export function CompactLongitudinalProfile(props: CompactLongitudinalProfileProps) {
  return <ProfileCore {...props} layout="compact" />;
}
